import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { Container } from 'components/domain/container';

export const TextContainer = styled(Container)<{ twoColumnView?: boolean }>(
  ({ theme }) => theme.text.richText,
  ({ twoColumnView }) =>
    sx2CssThemeFn({
      pt: ['50px', 9],
      pb: ['50px', 9],
      px: [3, '20px'],
      '.lead-text-wrapper': {
        width: ['100%', twoColumnView ? '100%' : '818px'],
        margin: `0 auto`,
      },
      '.lead-text, .long-text': {
        display: 'block',
        margin: `0 auto`,
        mb: 3,
        width: ['100%', '818px'],
      },
      '.long-text': {
        mb: 0,
      },
      '.long-text, .lead-text :last-child': {
        mb: 0,
      },
      '.lead-text': {
        display: 'inline',
        p: {
          display: 'inline',
          fontSize: [3, '24px'],
        },
      },
      a: {
        display: 'inline-block',
        textDecoration: 'initial',
        width: 'fit-content',
        '.link-text': {
          fontSize: '16px',
          display: 'inline',
        },
        '&:hover, &:focus, &:active': {
          textDecoration: 'initial',
        },
      },
      '.static-request-button-wrapper': {
        maxWidth: '818px',
        pt: 6,
      },
      '.lead-title': {
        fontSize: [7, '46px'],
        minWidth: ['auto', '560px'],
        mr: [0, 9],
        pt: 0,
        mb: 0,
      },
      ...(twoColumnView
        ? {
            display: 'flex',
            flexDirection: ['column', 'row'],
          }
        : {}),
    })
);
